import { useCallback } from "react";

import styled from "styled-components/macro";

import { useFamilyRegistrationContext } from "Signups/FamilyRegistration/FamilyRegistrationContext";
import useUpdateSetting from "Signups/FamilyRegistration/Shared/useUpdateSetting";

import FnrIcon from "UI/FnrIcon";
import { FnrToggleChild } from "UI/FnrToggle2";
import { colors } from "UI/colors";
import { TabBackground, TabText, TabWrapper } from "UI/tabBarStyles";

export default function AdminPanelNavigationTab({ panel, text, icon }) {
  const {
    state: { selectedPanel, familyRegistrationSettings, textboxes },
    setState,
  } = useFamilyRegistrationContext();

  const { updateSetting, saving } = useUpdateSetting();

  const checkForTextboxUpdates = useCallback(() => {
    for (let setting in textboxes) {
      const initialVal = familyRegistrationSettings[setting].message;
      const value = textboxes[setting];
      if (!saving && value !== null && value !== initialVal) {
        updateSetting({ setting, value });
        break;
      }
    }
  }, [familyRegistrationSettings, textboxes, updateSetting, saving]);

  const handleTabSelect = () => {
    checkForTextboxUpdates();
    setState({ selectedPanel: panel });
  };

  const selected = selectedPanel === panel;

  return (
    <TabWrapper data-cy="famRegMenuButton">
      <FnrToggleChild selected={selected} style={{ flex: 1 }}>
        <TabBackground onClick={handleTabSelect} selected={selected}>
          <FnrIcon fas icon={icon} />
          <TabText>{text}</TabText>
        </TabBackground>
      </FnrToggleChild>
    </TabWrapper>
  );
}
